module.exports = __webpack_public_path__ + "img/strategy-bg3.504fc993.jpg";